"use client";
import type { ReactElement } from "react";
import { FontWeight } from "@/theme/typography";
import { CmarkdownLabelText } from "../Cmarkdowntext/CmarkdownLabelText";
export interface GanttTooltipTitleProps {
    taskLabel: string;
}
export function GanttTooltipTitle({ taskLabel, }: GanttTooltipTitleProps): ReactElement {
    return (
      <div style={{ marginBottom: 6 }}>
        <CmarkdownLabelText dataElScope="Cmarkdowngantt/GanttTooltipTitle" content={taskLabel} size={12} weight={FontWeight.Bold} paragraphStyle={{ marginBottom: 0 }} textStyle={{ color: "rgba(255,255,255,0.95)", lineHeight: "16px" }}/>
      </div>
    );
}
